import { Grid, Checkbox } from "@mui/material";
import FormGroup from "@mui/material/FormGroup";
import { useRecoilState } from "recoil";
import { GetTypographyContent } from "../shared/Typography/Typography";
import {
  CheckboxLabelWrapper,
  StyledFormLabelPatient,
} from "./NewRequisition.styles";
import { currentNewRequisitionEdit } from "../../recoil/atoms";
import { patientCheckboxAlignmentSx } from "./testPanelStyles";

const PatientInformationEthnicity: React.FC<{ disabled?: boolean }> = ({
  disabled = false,
}) => {
  const [newRequisition, setNewRequisition] = useRecoilState(
    currentNewRequisitionEdit,
  );

  const { requisitionForm } = newRequisition;

  const onChangeCheckBox = (e: React.ChangeEvent<HTMLInputElement>) => {
    setNewRequisition({
      ...newRequisition,
      requisitionForm: {
        ...newRequisition.requisitionForm,
        [e.target.name]: e.target.checked,
      },
    });
  };
  return (
    <Grid
      container
      spacing={3}
      sx={{ py: 2 }}
      columns={{ xs: 4, sm: 8, md: 12 }}
    >
      <Grid item xs={4} sm={8} md={12}>
        <StyledFormLabelPatient
          disabled={disabled}
          sx={{ fontFamily: "light", pb: 0 }}
        >
          Ethnicity <span className="label_subtext">Select all that apply</span>
        </StyledFormLabelPatient>
      </Grid>
      <Grid item xs={4} sm={8} md={4}>
        <FormGroup sx={patientCheckboxAlignmentSx}>
          <CheckboxLabelWrapper
            id="new-test-patient-asian"
            control={
              <Checkbox
                disabled={disabled}
                checked={requisitionForm.asian}
                name="asian"
                onChange={onChangeCheckBox}
              />
            }
            label={GetTypographyContent({
              content: "Asian",
              size: "medium",
              textColor: "greyMedium",
            })}
          />
          <CheckboxLabelWrapper
            id="new-test-patient-middleEastern"
            control={
              <Checkbox
                disabled={disabled}
                checked={requisitionForm.middleEastern}
                name="middleEastern"
                onChange={onChangeCheckBox}
              />
            }
            label={GetTypographyContent({
              content: "Middle Eastern",
              size: "medium",
              textColor: "greyMedium",
            })}
          />
          <CheckboxLabelWrapper
            id="new-test-patient-white"
            control={
              <Checkbox
                disabled={disabled}
                checked={
                  requisitionForm.white || requisitionForm.northernEuropean
                }
                name="white"
                onChange={onChangeCheckBox}
              />
            }
            label={GetTypographyContent({
              content: "White",
              size: "medium",
              textColor: "greyMedium",
            })}
          />
        </FormGroup>
      </Grid>

      <Grid item xs={4} sm={8} md={4}>
        <FormGroup sx={patientCheckboxAlignmentSx}>
          <CheckboxLabelWrapper
            id="new-test-patient-african"
            control={
              <Checkbox
                disabled={disabled}
                checked={requisitionForm.african}
                name="african"
                onChange={onChangeCheckBox}
              />
            }
            label={GetTypographyContent({
              content: "African/African American",
              size: "medium",
              textColor: "greyMedium",
            })}
          />

          <CheckboxLabelWrapper
            id="new-test-patient-french"
            control={
              <Checkbox
                disabled={disabled}
                checked={requisitionForm.frenchCanadian}
                name="frenchCanadian"
                onChange={onChangeCheckBox}
              />
            }
            label={GetTypographyContent({
              content: "French Canadian or Cajun",
              size: "medium",
              textColor: "greyMedium",
            })}
          />
          <CheckboxLabelWrapper
            id="new-test-patient-other"
            control={
              <Checkbox
                disabled={disabled}
                checked={requisitionForm.otherEthnicity}
                name="otherEthnicity"
                onChange={onChangeCheckBox}
              />
            }
            label={GetTypographyContent({
              content: "Other",
              size: "medium",
              textColor: "greyMedium",
            })}
          />
        </FormGroup>
      </Grid>
      <Grid item xs={4} sm={8} md={4}>
        <FormGroup sx={patientCheckboxAlignmentSx}>
          <CheckboxLabelWrapper
            id="new-test-patient-ashkenazi"
            control={
              <Checkbox
                disabled={disabled}
                checked={requisitionForm.ashkenazi}
                name="ashkenazi"
                onChange={onChangeCheckBox}
              />
            }
            label={GetTypographyContent({
              content: "Ashkenazi Jewish",
              size: "medium",
              textColor: "greyMedium",
            })}
          />
          <CheckboxLabelWrapper
            id="new-test-patient-hispanic"
            control={
              <Checkbox
                disabled={disabled}
                checked={requisitionForm.hispanic}
                name="hispanic"
                onChange={onChangeCheckBox}
              />
            }
            label={GetTypographyContent({
              content: "Hispanic",
              size: "medium",
              textColor: "greyMedium",
            })}
          />
          <CheckboxLabelWrapper
            id="new-test-patient-unknown"
            control={
              <Checkbox
                disabled={disabled}
                checked={requisitionForm.unknownEthnicity}
                name="unknownEthnicity"
                onChange={onChangeCheckBox}
              />
            }
            label={GetTypographyContent({
              content: "Unknown",
              size: "medium",
              textColor: "greyMedium",
            })}
          />
        </FormGroup>
      </Grid>
    </Grid>
  );
};
export default PatientInformationEthnicity;
